module.exports = __webpack_public_path__ + "img/bg_snack_street.df1ca9e3.jpg";